<template>
  <button
    class="fixed bottom-5 right-5 z-[90] rounded-full shadow-lg bg-primary-600 hover:bg-primary-700 text-white w-12 h-12 flex items-center justify-center"
    @click="$emit('open')"
    title="Ouvrir le guide"
  >
    <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h3l2 2h5a2 2 0 012 2v10a2 2 0 01-2 2z" />
    </svg>
  </button>
</template>

<script setup lang="ts">
defineEmits(['open'])
</script>


